"use strict";

(function () {
  'use strict';

  function tripCompactCtrl($filter) {
    var vm = this;

    this.getRelativeTime = function (group) {
      var _groups = {
        current: $filter('relativeCheckOut')(vm.endDate),
        upcoming: $filter('relativeCheckIn')(vm.startDate)
      };

      if (_groups.hasOwnProperty(group)) {
        return _groups[group];
      }
    };

    this.$onInit = function () {//console.log(this);
    };
  }

  tripCompactCtrl.$inject = ['$filter'];
  angular.module('trip-compact', []).component('tripCompact', {
    bindings: {
      transactionId: '@',
      adminCustDataId: '@',
      destination: '@',
      startDate: '@',
      endDate: '@',
      nights: '@',
      guests: '@',
      propertyName: '@',
      propertyImage: '@',
      managerName: '@',
      managerLogo: '@',
      relativeText: '@',
      status: '@',
      balanceDue: '@',
      agreementStatus: '@',
      group: '@'
    },
    controller: tripCompactCtrl,
    templateUrl: 'components/trip-compact/trip-compact.html'
  }).component('tripCompactLoading', {
    templateUrl: 'components/trip-compact/trip-compact-loading.html'
  });
})();